import { render } from "./SeeYouSoon.vue?vue&type=template&id=50f36d76&scoped=true"
import script from "./SeeYouSoon.vue?vue&type=script&lang=js"
export * from "./SeeYouSoon.vue?vue&type=script&lang=js"

import "./SeeYouSoon.vue?vue&type=style&index=0&id=50f36d76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50f36d76"

export default script